// import {
//   Box,
//   Container,
//   Grid,
//   Typography,
//   IconButton,
//   Link,
//   Divider,
//   Stack,
//   useTheme,
// } from "@mui/material";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
// import bjsLogo from "../../../images/bjsLogoWhiteBG.png"; 

// const LandingPageFooter = () => {
//   const theme = useTheme();
//   const bg = theme.palette.primary?.main;
//   const lightText = "#ffffff";

//   return (
//     <Box
//       component="footer"
//       sx={{ bgcolor: bg, color: lightText, position: "relative", pt: 6, pb: 6 }}
//     >
//       <Container maxWidth="lg">
//         <Grid
//           container
//           spacing={4}
//           alignItems="flex-start"
//           sx={{
//             borderTop: `1px solid ${theme.palette.common.white}20`,
//             pt: 3,
//           }}
//         >
//           {/* Left Section: Logo + Socials */}
//           <Grid item xs={12} md={3}>
//             <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//               <Box
//                 component="img"
//                 src={bjsLogo}
//                 alt="BJS Logo"
//                 sx={{ width: 140 }}
//               />
//               <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
//                 <IconButton
//                   href="https://www.facebook.com/bhartiyajainsanghatana"
//                   target="_blank"
//                   sx={{ bgcolor: "rgba(255,255,255,0.08)", color: lightText }}
//                 >
//                   <FacebookIcon />
//                 </IconButton>
//                 <IconButton
//                   href="https://www.instagram.com/bhartiyajainsanghatana/"
//                   target="_blank"
//                   sx={{ bgcolor: "rgba(255,255,255,0.08)", color: lightText }}
//                 >
//                   <InstagramIcon />
//                 </IconButton>
//                 <IconButton
//                   href="https://www.youtube.com/@BJSIndia1985"
//                   target="_blank"
//                   sx={{ bgcolor: "rgba(255,255,255,0.08)", color: lightText }}
//                 >
//                   <YouTubeIcon />
//                 </IconButton>
//                 <IconButton
//                   href="https://x.com/BJS_India"
//                   target="_blank"
//                   sx={{ bgcolor: "rgba(255,255,255,0.08)", color: lightText }}
//                 >
//                   <TwitterIcon />
//                 </IconButton>
//                 <IconButton
//                   href="https://www.linkedin.com/company/bjs-india/"
//                   target="_blank"
//                   sx={{ bgcolor: "rgba(255,255,255,0.08)", color: lightText }}
//                 >
//                   <LinkedInIcon />
//                 </IconButton>
//               </Stack>
//               <Typography
//                 variant="subtitle2"
//                 sx={{ mt: 1, color: "rgba(255,255,255,0.9)", fontWeight: 600 }}
//               >
//                 Follow Us
//               </Typography>
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Box>
//               <Box
//                 component="nav"
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   gap: 6,
//                   mb: 3,
//                   flexWrap: "wrap",
//                 }}
//               >
//                 {["Join Us", "Journey", "Volunteers", "Programs"].map(
//                   (item) => (
//                     <Link
//                       key={item}
//                       href="#"
//                       underline="none"
//                       sx={{
//                         color: theme.palette.common.white,
//                         fontWeight: 800, 
//                         fontSize: 15,
//                         letterSpacing: 0.2,
//                         "&:hover": { opacity: 0.9 },
//                       }}
//                     >
//                       {item}
//                     </Link>
//                   )
//                 )}
//               </Box>

//               <Grid
//                 container
//                 spacing={2}
//                 alignItems="flex-start"
//                 justifyContent="center"
//               >
//                 <Grid item xs={12} sm={6}>
//                   <Box sx={{ maxWidth: 360  }}>
//                     <Typography
//                       variant="subtitle1"
//                       sx={{ fontWeight: 700, mb: 1 }}
//                     >
//                       About Us
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{ color: "rgba(255,255,255,0.9)", lineHeight: 1.6 }}
//                     >
//                       Integer posuere mollis nisi ut bibendum. Cras nec posuere
//                       sapien. Nullam semper mi vel nisi tempus, vel blandit
//                       ligula sagittis.
//                     </Typography>
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <Box sx={{ maxWidth: 320 }}>
//                     <Typography
//                       variant="subtitle1"
//                       sx={{ fontWeight: 700, mb: 1 }}
//                     >
//                       Other Companies
//                     </Typography>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "column",
//                         gap: 0.75,
//                       }}
//                     >
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "rgba(255,255,255,0.95)" }}
//                       >
//                         Shantilal Muttha Foundation
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "rgba(255,255,255,0.95)" }}
//                       >
//                         Medhakshar
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <Box
//               sx={{
//                 pl: { md: 3 },
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 2,
//               }}
//             >
//               <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                 Let’s Connect
//               </Typography>

//               <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                 <Typography variant="body2" sx={{ fontWeight: 700 }}>
//                   Call
//                 </Typography>
//                 <Link
//                   href="tel:+918855018170"
//                   underline="none"
//                   sx={{
//                     color: lightText,
//                     fontWeight: 600,
//                   }}
//                 >
//                   +91 885 501 8170
//                 </Link>
//               </Box>

//               <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                 <Typography variant="body2" sx={{ fontWeight: 700 }}>
//                   Email
//                 </Typography>
//                 <Link
//                   href="mailto:info@bjsindia.org"
//                   underline="none"
//                   sx={{
//                     color: lightText,
//                     fontWeight: 600,
//                   }}
//                 >
//                   info@bjsindia.org
//                 </Link>
//               </Box>
//             </Box>
//           </Grid>
//         </Grid>

//       </Container>

//       <IconButton
//         href="mailto:info@bjsindia.org"
//         color="primary"
//         aria-label="Contact Us"
//         sx={{
//           position: "absolute",
//           right: 24,
//           bottom: 24,
//           bgcolor: "rgba(255,255,255,0.12)",
//           color: lightText,
//           width: 56,
//           height: 56,
//           "&:hover": { bgcolor: "rgba(255,255,255,0.18)" },
//         }}
//       >
//         <HeadsetMicIcon />
//       </IconButton>
//       <footer className="footer">
//           <div className="footer-bottom">
//             ©2025 | BJS India | All rights reserved.
//           </div>{" "}
//         </footer>
//     </Box>

//   );
// };

// export default LandingPageFooter;















import React from "react";
import {Box} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import bjsLogo from "../../../images/WhiteBJSEnglish1.svg";

const socialLinks = [
  {
    href: "https://www.facebook.com/BJSIndia",
    icon: <FacebookIcon fontSize="small" />,
    label: "Facebook",
  },
  {
    href: "https://www.instagram.com/bhartiyajainsanghatana/",
    icon: <InstagramIcon fontSize="small" />,
    label: "Instagram",
  },
  {
    href: "https://www.youtube.com/channel/UCFLe91tMq_twtQ7EDi97USQ",
    icon: <YouTubeIcon fontSize="small" />,
    label: "YouTube",
  },
  {
    href: "https://x.com/BJS_India",
    icon: <XIcon fontSize="small" />,
    label: "X",
  },
  {
    href: "https://www.linkedin.com/company/bjs-india/posts/?feedView=all",
    icon: <LinkedInIcon fontSize="small" />,
    label: "LinkedIn",
  },
];

const LandingPageFooter = () => {
  const bg = "#0A0A0A";

  return (
    <footer className="text-white px-4 py-6" style={{ backgroundColor: bg }}>

      {/* ================= MOBILE ================= */}
      <div className="block md:hidden max-w-md mx-auto">

        {/* About */}
        <div className="mb-5">
          <h6 className="font-bold text-base mb-2">About Us</h6>
          <p className="text-sm text-white/90 leading-relaxed">
            Bharatiya Jain Sanghatana is committed to empowering communities
            through education and social initiatives across India.
          </p>
        </div>

        {/* Other Companies */}
        <div className="border border-white/30 rounded-md p-3 mb-6">
          <h6 className="font-bold text-sm mb-2">Other Organizations</h6>
          <div className="flex justify-between text-sm text-white/90">
            <a href="https://mutthafoundation.org/" target="_blank">
              Shantilal Muttha Foundation
            </a>
            <a href="https://www.medhakshar.com/" target="_blank">
              Medhakshar
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex justify-between items-center">
          <div className="flex flex-col gap-4">
            {/* <img src={bjsLogo} className="w-20 h-20 object-contain" /> */}

            <div>
              <img src={bjsLogo} className="w-20 h-20 object-contain mb-3" />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  flexDirection: {xs:"column", sm:"row"},
                  gap: 2,
                  flexWrap: "wrap", // optional for very small screens
                }}
              >
                <p className="text-sm font-semibold m-0">
                  Let's Connect : +91 95451 11551
                </p>

                <p className="text-sm font-semibold m-0">
                  Email : info@bjsindia.org
                </p>
              </Box>
            </div>

            <div>
              <p className="font-semibold mb-2">Follow Us</p>

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                {socialLinks.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white/10 w-8 h-8 rounded-full flex items-center justify-center"
                  >
                    {link.icon}
                  </a>
                ))}
              </Box>
            </div>
          </div>
        </div>
      </div>

      {/* ================= DESKTOP ================= */}
      <div className="hidden md:block max-w-6xl mx-auto">

        <div className="flex gap-10">

          {/* LEFT */}
          <div className="flex flex-col gap-3 w-1/4 border-r border-white/20">
            <img src={bjsLogo} className="w-28 h-28 object-contain" />

            <p className="font-semibold text-white/90">Follow Us</p>

            <Box sx={{display:"flex", flexDirection:"row", flexWrap:"wrap", gap:{xs:0.5, sm:1, md:2}, width:"70%"}}>
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  className="bg-white/10 w-6 h-6 rounded-full flex items-center justify-center hover:bg-white/20"
                >
                  {link.icon}
                </a>
              ))}
            </Box>
          </div>

          {/* MIDDLE */}
          <div className="flex flex-col w-2/4 px-6 border-r border-white/20 gap-4">
            <div>
              <h6 className="font-bold text-base mb-2">About Us</h6>
              <p className="text-sm text-white/90">
                Bharatiya Jain Sanghatana is committed to empowering communities
                through education, leadership, and social initiatives.
              </p>
            </div>

            <div>
              <h6 className="font-bold text-base mb-2">
                Other Organizations
              </h6>
              <div className="flex gap-4 text-sm text-white/90">
                <a href="https://mutthafoundation.org/" target="_blank">
                  Shantilal Muttha Foundation
                </a>
                <a href="https://www.medhakshar.com/" target="_blank">
                  Medhakshar
                </a>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex flex-col gap-4 w-1/4">
            <h6 className="text-lg font-bold">Let’s Connect</h6>

            <div>
              <p className="text-sm font-bold">Call</p>
              <p className="font-semibold">+91 95451 11551</p>
            </div>

            <div>
              <p className="text-sm font-bold">Email</p>
              <p className="font-semibold">info@bjsindia.org</p>
            </div>
          </div>

        </div>
      </div>

    </footer>
  );
};

export default LandingPageFooter;